export const VIDEOS = {
  video_1: "/360/videos/01-start.mp4",
  video_2: "/360/videos/02-Main Show_virtual tour_1920X1080_black.mp4",
  video_3: "/360/videos/03-Instruction.mp4",
  video_4: "/360/videos/04-donation.mp4",
  video_5: "/360/videos/05-kakal.mp4",
};

export type VideoKeys = keyof typeof VIDEOS
